import React from 'react';
import { styles } from '../styles/styles';
import mowerIcon from '../assets/service-icons/mower.png';
import trimmerIcon from '../assets/service-icons/trimmer.png';
import sprayerIcon from '../assets/service-icons/sprayer.png';
import mulchIcon from '../assets/service-icons/mulch.png';

const Services = () => {
  const services = [
    {
      icon: mowerIcon,
      title: "Professional Mowing",
      description: "Weekly lawn mowing services with precise cutting patterns for your property."
    },
    {
      icon: trimmerIcon,
      title: "Edging & Trimming",
      description: "Clean, crisp edges around walkways, driveways, and landscaping for that polished look."
    },
    {
      icon: sprayerIcon,
      title: "Weed Control",
      description: "Effective weed management to keep your Minnesota lawn healthy and looking its best year-round."
    },
    {
      icon: mulchIcon,
      title: "Mulch Installation",
      description: "Small mulch jobs to enhance your landscaping and protect your plants through Minnesota seasons."
    },
    // {
    //   icon: null, // add an icon image before re-enabling
    //   title: "Seasonal Cleanups",
    //   description: "Spring and fall cleanup services including leaf removal for Apple Valley, Rosemount, and Lakeville homes."
    // }
  ];

  return (
    <section id="services" style={styles.section}>
      <div style={styles.sectionContainer}>
        <h2 style={styles.sectionTitle}>Our Lawn Care Services</h2>
        <p style={styles.sectionDescription}>
          Comprehensive lawn care services for Apple Valley, Rosemount, Eagan, Burnsville, Lakeville and South Metro properties. Professional, reliable service.
        </p>
        <div style={styles.servicesGrid} className="services-grid">
          {services.map((service, index) => (
            <div 
              key={index}
              style={styles.serviceCard}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-4px)';
                e.currentTarget.style.boxShadow = '0 8px 25px rgba(0, 0, 0, 0.15)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.1)';
              }}
            >
              <div style={styles.serviceIcon}>
                <img
                  src={service.icon}
                  alt=""
                  style={{ width: '120px', height: '120px', objectFit: 'contain' }}
                />
              </div>
              <h3 style={styles.serviceTitle}>{service.title}</h3>
              <p style={styles.serviceDescription}>{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;